import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import SectionHeader from './SectionHeader';
import ResearchAccordion from './ResearchAccordion';
import { RESEARCH_SECTIONS } from './constants';

const OpenDoorResearchSection = ({ companyName }) => {
  // Multiple drawers can stay open at once; each keeps its own scroll area.
  const [expandedDrawers, setExpandedDrawers] = useState(() => new Set());

  const toggleDrawer = (id) => () => {
    setExpandedDrawers((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  return (
    <Box
      border={1}
      borderColor='divider'
      borderRadius={2}
      p={2.5}
      display='flex'
      flexDirection='column'
      minHeight={{ md: 640 }}
      sx={{ opacity: 0.85 }}
    >
      <SectionHeader
        number={3}
        title='Review AI research'
        subtitle='AI researched this company using trusted public sources.'
      />

      <Box
        border={1}
        borderColor='divider'
        borderRadius={1.5}
        bgcolor='#fff'
        p={2}
        mb={2}
        minHeight={100}
        display='flex'
        alignItems='center'
        justifyContent='center'
      >
        <Box textAlign='center'>
          <Typography variant='body2' fontWeight={700} mb={0.5}>
            Opportunity assessment
          </Typography>
          <Typography variant='body2' color='text.secondary' sx={{ fontStyle: 'italic' }}>
            under construction
          </Typography>
        </Box>
      </Box>

      <Box flex={1} borderTop={1} borderColor="divider">
        {RESEARCH_SECTIONS.map(({ id, title, icon, sourceCount }) => (
          <ResearchAccordion
            key={id}
            id={id}
            title={title}
            icon={icon}
            sourceCount={sourceCount}
            companyName={companyName}
            expanded={expandedDrawers.has(id)}
            onToggle={toggleDrawer(id)}
          />
        ))}
      </Box>

      <Box display='flex' alignItems='flex-start' gap={0.75} mt={1.5}>
        <InfoOutlinedIcon sx={{ fontSize: 14, color: 'text.secondary', mt: 0.15 }} />
        <Typography variant='caption' color='text.secondary'>
          Expand any section to view findings and original sources. Multiple sections can be open at
          once; each panel scrolls independently.
        </Typography>
      </Box>
    </Box>
  );
};

export default OpenDoorResearchSection;
